import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "audit-manager-container" }
const _hoisted_2 = { class: "audit-header-panel" }
const _hoisted_3 = { class: "header-stats" }
const _hoisted_4 = { class: "stat-pill" }
const _hoisted_5 = { class: "audit-main-card" }
const _hoisted_6 = { class: "table-title-cell" }
const _hoisted_7 = { class: "title-txt" }
const _hoisted_8 = { class: "author-txt" }
const _hoisted_9 = { class: "price-txt" }
const _hoisted_10 = { class: "remark-rejected-txt" }
const _hoisted_11 = { class: "table-actions-group" }
const _hoisted_12 = { class: "pagination-bar" }
const _hoisted_13 = { class: "audit-dialog-body" }
const _hoisted_14 = { class: "audit-section" }
const _hoisted_15 = { class: "chips-wrap" }
const _hoisted_16 = {
  key: 0,
  class: "empty-txt"
}
const _hoisted_17 = { class: "desc-cell-txt" }
const _hoisted_18 = { class: "desc-cell-txt" }
const _hoisted_19 = { class: "audit-section" }
const _hoisted_20 = { class: "media-gallery-grid" }
const _hoisted_21 = { class: "media-card" }
const _hoisted_22 = { class: "media-box" }
const _hoisted_23 = {
  key: 1,
  class: "none-txt"
}
const _hoisted_24 = { class: "media-card" }
const _hoisted_25 = { class: "media-box" }
const _hoisted_26 = {
  key: 1,
  class: "none-txt"
}
const _hoisted_27 = { class: "media-card" }
const _hoisted_28 = { class: "media-box" }
const _hoisted_29 = {
  key: 1,
  class: "none-txt"
}
const _hoisted_30 = { class: "audit-section" }
const _hoisted_31 = { class: "fast-actions-grid" }
const _hoisted_32 = { class: "action-info" }
const _hoisted_33 = { class: "title" }
const _hoisted_34 = { class: "dialog-footer-actions" }
const _hoisted_35 = { class: "sub-dialog-content" }
const _hoisted_36 = { class: "sub-title" }
const _hoisted_37 = { class: "sub-desc" }
const _hoisted_38 = {
  key: 0,
  class: "sub-image-box"
}
const _hoisted_39 = { class: "sub-dialog-content" }
const _hoisted_40 = { class: "sub-title" }
const _hoisted_41 = { class: "sub-desc" }
const _hoisted_42 = {
  key: 0,
  class: "sub-image-box"
}
const _hoisted_43 = { class: "level-audit-scroll" }
const _hoisted_44 = { class: "level-detail-block" }
const _hoisted_45 = { class: "sub-grid-2" }
const _hoisted_46 = {
  key: 0,
  class: "tip-content-box"
}
const _hoisted_47 = {
  key: 1,
  class: "sub-imgs-row"
}
const _hoisted_48 = {
  key: 2,
  class: "questions-audit-card"
}
const _hoisted_49 = { class: "q-title" }
const _hoisted_50 = { class: "q-answer" }
const _hoisted_51 = { class: "right-ans" }
const _hoisted_52 = { class: "options-list" }
const _hoisted_53 = { class: "level-footer-actions" }
const _hoisted_54 = { class: "tips-audit-list" }
const _hoisted_55 = { class: "tip-title" }
const _hoisted_56 = { class: "tip-txt" }
const _hoisted_57 = {
  key: 0,
  class: "tip-img-box"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[35] || (_cache[35] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "header-left" }, [
        _createElementVNode("h2", { class: "module-title" }, "剧本游戏上线审核控制台"),
        _createElementVNode("span", { class: "module-desc" }, "集中审核创作者提交的公测与正式版本资料包、谜题关卡与剧情合规性")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, "当前标签共 " + _toDisplayString(_ctx.total) + " 项记录", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_tabs, {
        modelValue: _ctx.activeName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeName) = $event)),
        class: "modern-audit-tabs",
        onTabClick: _ctx.handleClick
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: "待审核列表",
            name: "first"
          }),
          _createVNode(_component_el_tab_pane, {
            label: "已审核通过",
            name: "second"
          }),
          _createVNode(_component_el_tab_pane, {
            label: "未通过驳回",
            name: "third"
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onTabClick"]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: _ctx.tableData,
        class: "custom-audit-table",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "游戏封面",
            width: "100"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_image, {
                class: "table-cover-img",
                src: row.gameCover || _ctx.defaultCover,
                fit: "cover"
              }, null, 8, ["src"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "游戏标题",
            prop: "gameTitle",
            "min-width": "180"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(row.gameTitle || "未定名游戏"), 1),
                _createElementVNode("span", _hoisted_8, "By " + _toDisplayString(row.author || "平台创作者"), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "发布阶段",
            width: "130"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_tag, {
                type: row.publicStatus === 1 ? 'primary' : 'warning',
                effect: "light",
                round: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row.publicStatus === 1 ? "正式上线" : "公测版本"), 1)
                ]),
                _: 2
              }, 1032, ["type"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "模式",
            prop: "gameClass",
            width: "130"
          }),
          _createVNode(_component_el_table_column, {
            label: "语言",
            prop: "gameLanguage",
            width: "110"
          }),
          _createVNode(_component_el_table_column, {
            label: "价格",
            width: "100"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", _hoisted_9, _toDisplayString(row.purchaseMoney ? `¥${row.purchaseMoney}` : "免费"), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "提交时间",
            prop: "createTime",
            width: "170"
          }),
          (_ctx.activeName === 'third')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                label: "驳回原因",
                prop: "remark",
                "min-width": "180"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(row.remark || "未填写原因"), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            label: "操作",
            width: "120",
            align: "right",
            fixed: "right"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_11, [
                (_ctx.activeName === 'first')
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      size: "small",
                      class: "audit-btn",
                      onClick: ($event: any) => (_ctx.openAuditDialog(scope.row))
                    }, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode(" 审查详情 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.activeName === 'second')
                  ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                      key: 1,
                      title: "确定要撤销该游戏的上线批准状态吗？",
                      "confirm-button-text": "确定撤销",
                      "cancel-button-text": "取消",
                      "confirm-button-type": "danger",
                      onConfirm: ($event: any) => (_ctx.quash(scope.$index, scope.row))
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "danger",
                          plain: "",
                          size: "small"
                        }, {
                          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                            _createTextVNode("撤销发布", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onConfirm"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, _ctx.loadingTable]
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_el_pagination, {
          background: "",
          layout: "total, prev, pager, next",
          "current-page": _ctx.currentPage,
          "page-size": 10,
          total: _ctx.total,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["current-page", "total", "onCurrentChange"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.centerDialogVisible,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.centerDialogVisible) = $event)),
      title: "剧本游戏上线合规审查",
      width: "960px",
      class: "custom-audit-dialog",
      "destroy-on-close": "",
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_component_el_button, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.centerDialogVisible = false))
          }, {
            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
              _createTextVNode("暂不处理", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "danger",
            plain: "",
            onClick: _ctx.noPass
          }, {
            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
              _createTextVNode("不通过 · 驳回", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.pass,
            class: "pass-confirm-btn"
          }, {
            default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
              _createTextVNode(" 批准通过 · 立即发布 ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "section-title" }, [
              _createElementVNode("span", { class: "indicator" }),
              _createElementVNode("span", null, "基础档案与商业配置")
            ], -1)),
            _createVNode(_component_el_descriptions, {
              column: 3,
              border: "",
              class: "custom-descriptions"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, {
                  label: "游戏标题",
                  span: 2
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.form.gameTitle), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "体验定价" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.form.purchaseMoney ? `${_ctx.form.purchaseMoney} 元` : "免费"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "创作者" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.form.author || "未提供"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "剧本模式" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.form.gameClass || "-"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "语言设定" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.form.gameLanguage || "-"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "游玩时长" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.form.playTime || 0) + " 分钟 ", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "预计耗时" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.form.estimateTime || "-"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "适用年龄" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.form.playerAge || "-"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "起点描述" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.form.beginPoint || "-"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, {
                  label: "终点描述",
                  span: 2
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.form.endPoint || "-"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, {
                  label: "开放时间",
                  span: 3
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.form.openHour || "全天开放") + " (体验建议: " + _toDisplayString(_ctx.form.experienceTime || "不限") + ") ", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, {
                  label: "标签关键词",
                  span: 3
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parsedTips, (tag, idx) => {
                        return (_openBlock(), _createBlock(_component_el_tag, {
                          key: idx,
                          size: "small",
                          class: "tip-chip"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tag), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128)),
                      (_ctx.parsedTips.length === 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, "未设置标签"))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, {
                  label: "剧情背景简介",
                  span: 3
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.form.gameDesc || "未填写背景介绍"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, {
                  label: "研学特色说明",
                  span: 3
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.form.features || "未填写研学特色说明"), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "section-title" }, [
              _createElementVNode("span", { class: "indicator" }),
              _createElementVNode("span", null, "视觉资源与物料审查")
            ], -1)),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "media-name" }, "游戏横版封面", -1)),
                _createElementVNode("div", _hoisted_22, [
                  (_ctx.form.gameCover)
                    ? (_openBlock(), _createBlock(_component_el_image, {
                        key: 0,
                        src: _ctx.form.gameCover,
                        fit: "cover",
                        "preview-src-list": [_ctx.form.gameCover],
                        "preview-teleported": ""
                      }, null, 8, ["src", "preview-src-list"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_23, "未上传封面"))
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "media-name" }, "游学结业证明图", -1)),
                _createElementVNode("div", _hoisted_25, [
                  (_ctx.form.proveImg)
                    ? (_openBlock(), _createBlock(_component_el_image, {
                        key: 0,
                        src: _ctx.form.proveImg,
                        fit: "contain",
                        "preview-src-list": [_ctx.form.proveImg],
                        "preview-teleported": ""
                      }, null, 8, ["src", "preview-src-list"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_26, "无结业证书"))
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "media-name" }, "手绘/自定义底图", -1)),
                _createElementVNode("div", _hoisted_28, [
                  (_ctx.form.customizeMap)
                    ? (_openBlock(), _createBlock(_component_el_image, {
                        key: 0,
                        src: _ctx.form.customizeMap,
                        fit: "contain",
                        "preview-src-list": [_ctx.form.customizeMap],
                        "preview-teleported": ""
                      }, null, 8, ["src", "preview-src-list"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_29, "标准高德地图模式"))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "section-title" }, [
              _createElementVNode("span", { class: "indicator" }),
              _createElementVNode("span", null, "深度剧情与核心关卡核查")
            ], -1)),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", {
                class: "fast-action-card",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showLevel2 && _ctx.showLevel2(...args)))
              }, [
                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "action-info" }, [
                  _createElementVNode("span", { class: "title" }, "开场叙事与序章"),
                  _createElementVNode("span", { class: "desc" }, "核验初入游戏引导、开篇全屏立绘与说明")
                ], -1)),
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  size: "small"
                }, {
                  default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                    _createTextVNode("审查序章", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("div", {
                class: "fast-action-card",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showLevel && _ctx.showLevel(...args)))
              }, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("span", _hoisted_33, "关卡与谜题列表 (" + _toDisplayString(_ctx.form2.length) + "关)", 1),
                  _cache[20] || (_cache[20] = _createElementVNode("span", { class: "desc" }, "逐关审查位置定位、线索提示图与选择谜题", -1))
                ]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  size: "small"
                }, {
                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                    _createTextVNode("审查关卡", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("div", {
                class: "fast-action-card",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showLevel3 && _ctx.showLevel3(...args)))
              }, [
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "action-info" }, [
                  _createElementVNode("span", { class: "title" }, "终局真相与复盘"),
                  _createElementVNode("span", { class: "desc" }, "核验通关结局交付、复盘密钥与终章插图")
                ], -1)),
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  size: "small"
                }, {
                  default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                    _createTextVNode("审查终章", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.startVisible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.startVisible) = $event)),
      title: "开场序章剧情审查",
      width: "600px",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("h4", _hoisted_36, _toDisplayString(_ctx.form3.startTitle || "未定名序章标题"), 1),
          _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.form3.startContent || "暂无开场序言介绍"), 1),
          (_ctx.form3.startImg)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createVNode(_component_el_image, {
                  src: _ctx.form3.startImg,
                  fit: "contain",
                  "preview-src-list": [_ctx.form3.startImg],
                  "preview-teleported": ""
                }, null, 8, ["src", "preview-src-list"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.endVisible,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.endVisible) = $event)),
      title: "通关结局与复盘审查",
      width: "600px",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("h4", _hoisted_40, _toDisplayString(_ctx.form3.endTitle || "未定名通关结局"), 1),
          _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.form3.endContent || "暂无终章交代说明"), 1),
          (_ctx.form3.endImg)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _createVNode(_component_el_image, {
                  src: _ctx.form3.endImg,
                  fit: "contain",
                  "preview-src-list": [_ctx.form3.endImg],
                  "preview-teleported": ""
                }, null, 8, ["src", "preview-src-list"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.levelVisible,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.levelVisible) = $event)),
      width: "820px",
      title: "关卡线索与解谜全景审查",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_43, [
          (_ctx.form2 && _ctx.form2.length > 0)
            ? (_openBlock(), _createBlock(_component_el_collapse, { key: 0 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form2, (item, idx) => {
                    return (_openBlock(), _createBlock(_component_el_collapse_item, {
                      key: idx,
                      title: `第 ${idx + 1} 关：${item.levelTitle || '未命名关卡'}`,
                      name: idx
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("p", null, [
                              _cache[28] || (_cache[28] = _createElementVNode("strong", null, "实地地点：", -1)),
                              _createTextVNode(_toDisplayString(item.address || "未设置实景地标"), 1)
                            ]),
                            _createElementVNode("p", null, [
                              _cache[29] || (_cache[29] = _createElementVNode("strong", null, "坐标：", -1)),
                              _createTextVNode("Lat: " + _toDisplayString(item.lat) + " , Lng: " + _toDisplayString(item.lng), 1)
                            ])
                          ]),
                          (item.addressTipContent)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                _cache[30] || (_cache[30] = _createElementVNode("span", { class: "box-tag" }, "地点寻找线索", -1)),
                                _createElementVNode("p", null, _toDisplayString(item.addressTipContent), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (item.tipCover)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                _cache[31] || (_cache[31] = _createElementVNode("span", { class: "row-label" }, "关卡提示图：", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.splitImages(item.tipCover), (imgUrl, i) => {
                                  return (_openBlock(), _createBlock(_component_el_image, {
                                    key: i,
                                    src: imgUrl,
                                    fit: "cover",
                                    class: "thumb-box",
                                    "preview-src-list": _ctx.splitImages(item.tipCover),
                                    "preview-teleported": ""
                                  }, null, 8, ["src", "preview-src-list"]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (item.questions)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                _cache[33] || (_cache[33] = _createElementVNode("span", { class: "card-title" }, "互动谜题与选项核验", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.safeParseQuestions(item.questions), (qItem, qIdx) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: qIdx,
                                    class: "question-unit"
                                  }, [
                                    _createElementVNode("p", _hoisted_49, [
                                      _createElementVNode("strong", null, "题" + _toDisplayString(qIdx + 1) + ":", 1),
                                      _createTextVNode(" " + _toDisplayString(qItem.value), 1)
                                    ]),
                                    _createElementVNode("p", _hoisted_50, [
                                      _cache[32] || (_cache[32] = _createElementVNode("strong", null, "正确答案:", -1)),
                                      _createElementVNode("span", _hoisted_51, _toDisplayString(qItem.rightAnswer), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_52, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qItem.options, (opt, optIdx) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: optIdx,
                                          class: "opt-item"
                                        }, _toDisplayString(optIdx + 1) + ". " + _toDisplayString(opt.one), 1))
                                      }), 128))
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_53, [
                            (item.tips)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  type: "info",
                                  size: "small",
                                  plain: "",
                                  onClick: ($event: any) => (_ctx.showTips(item.tips))
                                }, {
                                  default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                                    _createTextVNode(" 查看该关卡求助线索 (Tips) ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["title", "name"]))
                  }), 128))
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_el_empty, {
                key: 1,
                description: "该游戏暂未录入任何关卡数据"
              }))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.tipVisible,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.tipVisible) = $event)),
      width: "560px",
      title: "关卡求助锦囊 (Tips)",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_54, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form4, (tip, tIdx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: tIdx,
              class: "tip-audit-card"
            }, [
              _createElementVNode("h5", _hoisted_55, "锦囊 " + _toDisplayString(tIdx + 1) + "：" + _toDisplayString(tip.tipTitle), 1),
              _createElementVNode("p", _hoisted_56, _toDisplayString(tip.tipContent), 1),
              (tip.tipPicture)
                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                    _createVNode(_component_el_image, {
                      src: tip.tipPicture,
                      fit: "contain",
                      "preview-src-list": [tip.tipPicture],
                      "preview-teleported": ""
                    }, null, 8, ["src", "preview-src-list"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _cache[36] || (_cache[36] = _createElementVNode("div", { class: "zhanwei3" }, null, -1))
  ]))
}